import React from "react";

// css
import "./di-styles.css";

const FourthUtility = () => {
  return (
    <section id="fourth-utility" className="fourth-utility-wrapper">
      <div className="main-padding">
        <div className="main-margin">
          <div className="half-div">
            <h1 className="sub-header">The Fourth Utility</h1>
            <p>
              Once seen as an added customer benefit, reliable connectivity
              without restriction – all the time, at full speed, on any device,
              from anywhere – has become the expectation in our connected world.
              This expectation is why many now consider digital infrastructure
              (and the connectivity it provides) a “fourth utility” that is
              nearly just as crucial as water, gas and electricity.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FourthUtility;
